/**
 * Quando saltare reCAPTCHA: in sviluppo (vite dev) e nelle build dell'ambiente di prova con
 * VITE_RECAPTCHA_DISABLED=true (dev.flusia.it, MD/architecture/staging-dev-flusia.md).
 * In produzione la variabile non c'e': reCAPTCHA resta acceso.
 */
export function recaptchaBypassed(env: { DEV?: boolean; VITE_RECAPTCHA_DISABLED?: string }): boolean {
  return env.DEV === true || env.VITE_RECAPTCHA_DISABLED === 'true';
}
